// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-main-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: calc(100vh - 150px);
  margin-top: 50px;
}

.auth-login-main-wrapper{
  min-height: calc(100vh - 200px);
}

.login-main-wrap {
  width: 447px;
}

.login-main-wrap h3 {
  font-size: 30px;
  color: #1a1919;
  font-weight: 700;
  margin-bottom: 32px;
  text-align: left;
}

.full {
  width: 100%;
}

.full.ordivider {
  margin: 30px 0px;
  border: 1px solid #f3f3f3;
  height: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ordivider span {
  display: block;
  background: #fff;
  padding: 0px 20px;
  font-size: 16px;
  font-weight: 400;
}

.login-screen-description p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  padding-top: 26px;
}

.login-text {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.login-text p,
.sign-up-text p {
  color: #00a19b;
  text-align: center;
  padding-top: 20px;
  font-size: 12px;
  font-weight: 500;
  margin: 0px;
  cursor: pointer;
}


.login-text p:hover,
.sign-up-text p:hover{
  color: #008081;
} 

.login-text p span {
  cursor: pointer;
}

.signup-main-wrapper {
  margin-top: 60px;
}

.field.phone-number-input {
  margin-bottom: 30px;
}

.field.phone-number-input img {
  position: absolute;
  top: 0px;
  right: 24px;
  width: 32px;
}

.field.phone-number-input input {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: none;
}

.PhoneInputCountry {
  border: 1px solid #f3f3f3;
  margin: 0px;
  margin-right: -6px !important;
  border-radius: 9px;
  padding: 16px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

input.PhoneInputInput::placeholder {
  color: #626262;
  line-height: 20px;
  font-size: 16px;
  font-weight: 300;
}

.error-msg p {
  padding-top: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #ff0000 !important;
}

.forget-password-otp-wrap p {
  font-size: 12px;
  color: #626262;
  font-weight: 400;
  margin: 0px;
  padding-top: 14px;
}

.forget-password-otp-wrap {
  margin-bottom: 24px;
}

.forget-password-otp-wrap .pin-code.password-otp-input input {
  text-align: center;
  width: 62px;
  height: 62px;
  margin-right: 11px;
}

.email-confirmation-wrapper {
  text-align: center;
}

.email-confirmation-icon {
  margin-bottom: 34px;
}

.email-confirmation-icon img {
  width: 118px;
}

.email-confirmation-wrapper .login-main-wrap {
  width: 500px;
}

.email-confirmation-wrapper .login-main-wrap h3 {
  text-align: center !important;
}

.email-confirmation-wrapper .login-main-wrap p {
  margin-bottom: 50px;
  font-size: 16px;
  color: #1a1919;
  font-weight: 400;
}

.email-confirmation-wrapper.login-main-wrapper {
  margin-top: 0px;
}

.email-confirmation-wrapper .login-main-wrap h3 {
  margin-bottom: 12px;
}

.auth-code-content {
  margin-bottom: 150px;
}

.auth-code-content p {
  font-size: 20px;
  font-weight: 400;
  color: #1a1919;
  margin: 0px;
}

.authenticate-twofa-otp-wrap {
  margin-bottom: 150px;
}

.authentication-code-main-wrapper {
  margin-top: 20px;
}

.otp-message-main-wrap{
  display: flex;
  /* justify-content: space-between; */
}

.resend-button button{
  /* width: 150px;
  height: 40px;
  font-size: 12px; */
  margin-top: 20px;
}

.resend-button p{
  font-size: 14px;
  color: #00A19B;
  margin-left: 10px;
  cursor: pointer;
}

.login-captcha-btn-wrap{
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.auth-login-main-wrap{
  text-align: center;
}

.auth-login-main-wrap h3{
  text-align: center;
}

.process-loading-gif {
  width: 160px;
  text-align: center;
  margin: 0 auto;
}

.phone-number-wrapper h3{
  text-align: left;
}

.phone-number-wrapper .error-msg p{
  padding-top: 0px;
  text-align: left;
}

/******* Resposive css ****/
@media (max-width: 1024px) {
  .login-main-wrap {
    width: 447px;
  }

  .forget-password-otp-wrap .pin-code.password-otp-input input {
    margin-right: 10px;
  }

  .login-main-wrap h3 {
    font-size: 28px;
    margin-bottom: 34px;
  }

  .full.ordivider {
    margin: 26px 0px;
  }

  .email-confirmation-icon img {
    width: 80px;
  }

  .email-confirmation-wrapper .login-main-wrap p {
    margin-bottom: 50px;
    font-size: 14px;
  }

  .authentication-code-main-wrapper {
    margin-top: 20px;
  }

  .auth-code-content {
    margin-bottom: 100px;
  }

  .auth-code-content p {
    font-size: 18px;
  }

  .authenticate-twofa-otp-wrap {
    margin-bottom: 100px;
  }

  .authenticate-twofa-otp-wrap .pin-code.password-otp-input input {
    width: 58px;
    height: 58px;
    margin-right: 11px;
    font-size: 12px;
  }

  .password-err-msg p {
    font-size: 12px;
  }
}

@media (max-width: 500px) {
  .login-main-wrap {
    width: 100%;
  }

  .email-confirmation-wrapper .login-main-wrap {
    width: 100%;
  }

  .forget-password-otp-wrap .pin-code.password-otp-input {
    justify-content: flex-start;
    width: 100%;
    display: grid;
    grid-template-columns: auto auto auto auto auto auto;
    gap: 6px;
  }

  .forget-password-otp-wrap .pin-code.password-otp-input input {
    text-align: center;
    width: 100%;
    height: 62px;
  }

  .authentication-code-main-wrapper {
    margin-top: 20px;
  }

  .auth-code-content {
    margin-bottom: 100px;
  }

  .auth-code-content p {
    font-size: 18px;
  }

  .authenticate-twofa-otp-wrap {
    margin-bottom: 100px;
  }

  .authenticate-twofa-otp-wrap .pin-code.password-otp-input {
    display: grid;
    grid-template-columns: auto auto auto auto auto auto;
    gap: 6px;
  }

  .authenticate-twofa-otp-wrap .pin-code.password-otp-input input {
    width: 100%;
    height: 52px;
    margin-right: 11px;
    font-size: 12px;
  }

  .login-main-wrap h3 {
    font-size: 24px;
    margin-bottom: 26px;
  }
}

@media (max-width: 380px) {
  .login-text p,
  .sign-up-text p {
    font-size: 10px;
  }

  .forget-password-otp-wrap .pin-code.password-otp-input input {
    height: 56px;
  }
}

@media (max-width: 330px) {
  .login-text p,
  .sign-up-text p {
    font-size: 9px;
  }

  .login-main-wrap h3 {
    font-size: 24px;
  }

  .login-screen-description p {
    font-size: 12px;
  }

  .forget-password-otp-wrap .pin-code.password-otp-input input {
    height: 50px;
  }

  .email-confirmation-icon img {
    width: 80px;
  }

  .email-confirmation-wrapper .login-main-wrap p {
    margin-bottom: 50px;
    font-size: 13px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .login-main-wrap {
    width: 447px;
  }

  .password-err-msg p {
    font-size: 12px;
  }
}

@media (min-width: 1025px) and (max-width: 1199px) {
  .login-main-wrap h3 {
    font-size: 24px;
    margin-bottom: 26px;
  }

  .full.ordivider {
    margin: 26px 0px;
  }

  .signup-main-wrapper {
    margin-top: 50px;
  }

  .forget-password-otp-wrap .pin-code.password-otp-input input {
    margin-right: 11px;
  }

  .authentication-code-main-wrapper {
    margin-top: 40px;
  }

  .auth-code-content {
    margin-bottom: 100px;
  }

  .auth-code-content p {
    font-size: 18px;
  }

  .authenticate-twofa-otp-wrap {
    margin-bottom: 100px;
  }

  .authenticate-twofa-otp-wrap .pin-code.password-otp-input input {
    width: 58px;
    height: 58px;
    margin-right: 11px;
    font-size: 12px;
  }

  .password-err-msg p {
    font-size: 12px;
  }
}

@media (min-width: 1025px) and (max-width: 1599px) {
  .login-main-wrap h3 {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .full.ordivider {
    margin: 26px 0px;
  }

  .signup-main-wrapper {
    margin-top: 50px;
  }

  .forget-password-otp-wrap .pin-code.password-otp-input input {
    margin-right: 11px;
  }

  .email-confirmation-icon img {
    width: 100px;
  }

  .authentication-code-main-wrapper {
    margin-top: 40px;
  }

  .auth-code-content {
    margin-bottom: 100px;
  }

  .auth-code-content p {
    font-size: 18px;
  }

  .authenticate-twofa-otp-wrap {
    margin-bottom: 100px;
  }

  .authenticate-twofa-otp-wrap .pin-code.password-otp-input input {
    width: 58px;
    height: 58px;
    margin-right: 11px;
    font-size: 12px;
  }

  .password-err-msg p {
    font-size: 12px;
  }

  .login-captcha-btn-wrap{
    gap: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/auth/login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;;AAGA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE;;oBAEkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,oDAAoD;IACpD,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".login-main-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  min-height: calc(100vh - 150px);\r\n  margin-top: 50px;\r\n}\r\n\r\n.auth-login-main-wrapper{\r\n  min-height: calc(100vh - 200px);\r\n}\r\n\r\n.login-main-wrap {\r\n  width: 447px;\r\n}\r\n\r\n.login-main-wrap h3 {\r\n  font-size: 30px;\r\n  color: #1a1919;\r\n  font-weight: 700;\r\n  margin-bottom: 32px;\r\n  text-align: left;\r\n}\r\n\r\n.full {\r\n  width: 100%;\r\n}\r\n\r\n.full.ordivider {\r\n  margin: 30px 0px;\r\n  border: 1px solid #f3f3f3;\r\n  height: 0px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.ordivider span {\r\n  display: block;\r\n  background: #fff;\r\n  padding: 0px 20px;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n\r\n.login-screen-description p {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  padding-top: 26px;\r\n}\r\n\r\n.login-text {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.login-text p,\r\n.sign-up-text p {\r\n  color: #00a19b;\r\n  text-align: center;\r\n  padding-top: 20px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.login-text p:hover,\r\n.sign-up-text p:hover{\r\n  color: #008081;\r\n} \r\n\r\n.login-text p span {\r\n  cursor: pointer;\r\n}\r\n\r\n.signup-main-wrapper {\r\n  margin-top: 60px;\r\n}\r\n\r\n.field.phone-number-input {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.field.phone-number-input img {\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 24px;\r\n  width: 32px;\r\n}\r\n\r\n.field.phone-number-input input {\r\n  border-top-left-radius: 0px;\r\n  border-bottom-left-radius: 0px;\r\n  border-left: none;\r\n}\r\n\r\n.PhoneInputCountry {\r\n  border: 1px solid #f3f3f3;\r\n  margin: 0px;\r\n  margin-right: -6px !important;\r\n  border-radius: 9px;\r\n  padding: 16px;\r\n  border-top-right-radius: 0px;\r\n  border-bottom-right-radius: 0px;\r\n}\r\n\r\ninput.PhoneInputInput::placeholder {\r\n  color: #626262;\r\n  line-height: 20px;\r\n  font-size: 16px;\r\n  font-weight: 300;\r\n}\r\n\r\n.error-msg p {\r\n  padding-top: 10px;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #ff0000 !important;\r\n}\r\n\r\n.forget-password-otp-wrap p {\r\n  font-size: 12px;\r\n  color: #626262;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  padding-top: 14px;\r\n}\r\n\r\n.forget-password-otp-wrap {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.forget-password-otp-wrap .pin-code.password-otp-input input {\r\n  text-align: center;\r\n  width: 62px;\r\n  height: 62px;\r\n  margin-right: 11px;\r\n}\r\n\r\n.email-confirmation-wrapper {\r\n  text-align: center;\r\n}\r\n\r\n.email-confirmation-icon {\r\n  margin-bottom: 34px;\r\n}\r\n\r\n.email-confirmation-icon img {\r\n  width: 118px;\r\n}\r\n\r\n.email-confirmation-wrapper .login-main-wrap {\r\n  width: 500px;\r\n}\r\n\r\n.email-confirmation-wrapper .login-main-wrap h3 {\r\n  text-align: center !important;\r\n}\r\n\r\n.email-confirmation-wrapper .login-main-wrap p {\r\n  margin-bottom: 50px;\r\n  font-size: 16px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n}\r\n\r\n.email-confirmation-wrapper.login-main-wrapper {\r\n  margin-top: 0px;\r\n}\r\n\r\n.email-confirmation-wrapper .login-main-wrap h3 {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.auth-code-content {\r\n  margin-bottom: 150px;\r\n}\r\n\r\n.auth-code-content p {\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n  color: #1a1919;\r\n  margin: 0px;\r\n}\r\n\r\n.authenticate-twofa-otp-wrap {\r\n  margin-bottom: 150px;\r\n}\r\n\r\n.authentication-code-main-wrapper {\r\n  margin-top: 20px;\r\n}\r\n\r\n.otp-message-main-wrap{\r\n  display: flex;\r\n  /* justify-content: space-between; */\r\n}\r\n\r\n.resend-button button{\r\n  /* width: 150px;\r\n  height: 40px;\r\n  font-size: 12px; */\r\n  margin-top: 20px;\r\n}\r\n\r\n.resend-button p{\r\n  font-size: 14px;\r\n  color: #00A19B;\r\n  margin-left: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-captcha-btn-wrap{\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.auth-login-main-wrap{\r\n  text-align: center;\r\n}\r\n\r\n.auth-login-main-wrap h3{\r\n  text-align: center;\r\n}\r\n\r\n.process-loading-gif {\r\n  width: 160px;\r\n  text-align: center;\r\n  margin: 0 auto;\r\n}\r\n\r\n.phone-number-wrapper h3{\r\n  text-align: left;\r\n}\r\n\r\n.phone-number-wrapper .error-msg p{\r\n  padding-top: 0px;\r\n  text-align: left;\r\n}\r\n\r\n/******* Resposive css ****/\r\n@media (max-width: 1024px) {\r\n  .login-main-wrap {\r\n    width: 447px;\r\n  }\r\n\r\n  .forget-password-otp-wrap .pin-code.password-otp-input input {\r\n    margin-right: 10px;\r\n  }\r\n\r\n  .login-main-wrap h3 {\r\n    font-size: 28px;\r\n    margin-bottom: 34px;\r\n  }\r\n\r\n  .full.ordivider {\r\n    margin: 26px 0px;\r\n  }\r\n\r\n  .email-confirmation-icon img {\r\n    width: 80px;\r\n  }\r\n\r\n  .email-confirmation-wrapper .login-main-wrap p {\r\n    margin-bottom: 50px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .authentication-code-main-wrapper {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .auth-code-content {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .auth-code-content p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap .pin-code.password-otp-input input {\r\n    width: 58px;\r\n    height: 58px;\r\n    margin-right: 11px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .password-err-msg p {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  .login-main-wrap {\r\n    width: 100%;\r\n  }\r\n\r\n  .email-confirmation-wrapper .login-main-wrap {\r\n    width: 100%;\r\n  }\r\n\r\n  .forget-password-otp-wrap .pin-code.password-otp-input {\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: auto auto auto auto auto auto;\r\n    gap: 6px;\r\n  }\r\n\r\n  .forget-password-otp-wrap .pin-code.password-otp-input input {\r\n    text-align: center;\r\n    width: 100%;\r\n    height: 62px;\r\n  }\r\n\r\n  .authentication-code-main-wrapper {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .auth-code-content {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .auth-code-content p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap .pin-code.password-otp-input {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto auto auto auto;\r\n    gap: 6px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap .pin-code.password-otp-input input {\r\n    width: 100%;\r\n    height: 52px;\r\n    margin-right: 11px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .login-main-wrap h3 {\r\n    font-size: 24px;\r\n    margin-bottom: 26px;\r\n  }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n  .login-text p,\r\n  .sign-up-text p {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .forget-password-otp-wrap .pin-code.password-otp-input input {\r\n    height: 56px;\r\n  }\r\n}\r\n\r\n@media (max-width: 330px) {\r\n  .login-text p,\r\n  .sign-up-text p {\r\n    font-size: 9px;\r\n  }\r\n\r\n  .login-main-wrap h3 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .login-screen-description p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .forget-password-otp-wrap .pin-code.password-otp-input input {\r\n    height: 50px;\r\n  }\r\n\r\n  .email-confirmation-icon img {\r\n    width: 80px;\r\n  }\r\n\r\n  .email-confirmation-wrapper .login-main-wrap p {\r\n    margin-bottom: 50px;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .login-main-wrap {\r\n    width: 447px;\r\n  }\r\n\r\n  .password-err-msg p {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1199px) {\r\n  .login-main-wrap h3 {\r\n    font-size: 24px;\r\n    margin-bottom: 26px;\r\n  }\r\n\r\n  .full.ordivider {\r\n    margin: 26px 0px;\r\n  }\r\n\r\n  .signup-main-wrapper {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .forget-password-otp-wrap .pin-code.password-otp-input input {\r\n    margin-right: 11px;\r\n  }\r\n\r\n  .authentication-code-main-wrapper {\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .auth-code-content {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .auth-code-content p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap .pin-code.password-otp-input input {\r\n    width: 58px;\r\n    height: 58px;\r\n    margin-right: 11px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .password-err-msg p {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1599px) {\r\n  .login-main-wrap h3 {\r\n    font-size: 22px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .full.ordivider {\r\n    margin: 26px 0px;\r\n  }\r\n\r\n  .signup-main-wrapper {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .forget-password-otp-wrap .pin-code.password-otp-input input {\r\n    margin-right: 11px;\r\n  }\r\n\r\n  .email-confirmation-icon img {\r\n    width: 100px;\r\n  }\r\n\r\n  .authentication-code-main-wrapper {\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .auth-code-content {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .auth-code-content p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .authenticate-twofa-otp-wrap .pin-code.password-otp-input input {\r\n    width: 58px;\r\n    height: 58px;\r\n    margin-right: 11px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .password-err-msg p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .login-captcha-btn-wrap{\r\n    gap: 18px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
